<ng-container *rxLet="vm$; let vm;">
  <app-form-select
    [formControl]="formControl"
    label="Repair Type"
    [data]="vm.repairTypes"
    [loading]="vm.loading"
    (itemSelected)="repairTypeChanged.emit($event)"></app-form-select>
</ng-container>
